export const createCancelOrderDetailsRequest = (salesOrderNumber: string, lastName: string) => ({
  path: { salesOrderNumber },
  query: { lastName },
});
